export interface TemplateNode {
  type: string;
  attrs?: Record<string, unknown>;
  content?: { type: string; text?: string }[];
}

export interface EditorTemplate {
  type: 'doc';
  content: TemplateNode[];
}

const heading = (level: number, text: string): TemplateNode => ({
  type: 'heading',
  attrs: { level },
  content: [{ type: 'text', text }],
});

const paragraph = (): TemplateNode => ({ type: 'paragraph' });

export const soapTemplate: EditorTemplate = {
  type: 'doc',
  content: [
    heading(2, 'Subjective'),
    paragraph(),
    heading(2, 'Objective'),
    paragraph(),
    heading(2, 'Assessment'),
    paragraph(),
    heading(2, 'Plan'),
    paragraph(),
  ],
};

export const riskAssessmentTemplate: EditorTemplate = {
  type: 'doc',
  content: [
    heading(2, 'Risk factors'),
    paragraph(),
    heading(2, 'Protective factors'),
    paragraph(),
    heading(2, 'Risk level'),
    paragraph(),
    heading(2, 'Safety plan'),
    paragraph(),
    heading(2, 'Follow-up'),
    paragraph(),
  ],
};
